import { Breadcrumb } from 'antd';
import { AppLink } from 'shared/UI/UIKit/Link';
import { AppSkeleton } from 'shared/UI/UIKit/Skeleton';
import { AppChevronLeftIcon } from 'shared/UI/UIKit/icons/Chevron';
import type { AppBreadcrumbsProps } from './Breadcrumbs.types';
import styles from './Breadcrumbs.module.scss';

export const AppBreadcrumbs = ({ items, loading, separator }: AppBreadcrumbsProps) => {
  if (loading) {
    return <AppSkeleton className={styles.skeleton} />;
  }

  if (!items.length) {
    return null;
  }

  const breadcrumbItems = items.map((item, index) => {
    const isLast = index === items.length - 1;

    const content = (
      <span className={styles.content}>
        {item.icon && <span className={styles.icon}>{item.icon}</span>}
        <span>{item.title}</span>
      </span>
    );

    return {
      key: `${item.url}-${index}`,
      title: isLast ? (
        <span className={styles.last}>{content}</span>
      ) : (
        <AppLink to={item.url} className={styles.link}>
          {content}
        </AppLink>
      ),
    };
  });

  return (
    <Breadcrumb
      className={styles.breadcrumbs}
      items={breadcrumbItems}
      separator={separator ?? <AppChevronLeftIcon className={styles.chevron} />}
    />
  );
};
